import { ReactNode, createContext, useEffect, useMemo, useState } from 'react';

import services from 'services';
import { DialogErrorItem, MainErrorItem } from 'types';
import { ErrorDialog } from 'view/components/ErrorView';

type ErrorContextValue = {
  main: MainErrorItem | undefined | null;
  dialog: DialogErrorItem | undefined | null;
};
export const ErrorContext = createContext<ErrorContextValue>({ main: null, dialog: null });

type ErrorProviderProps = {
  children: ReactNode;
};

const ErrorProvider = ({ children }: ErrorProviderProps) => {
  const [mainError, setMainError] = useState<MainErrorItem | undefined>(services.appFrame.error.main.getError);
  useEffect(() => services.appFrame.error.main.onErrorChange((newError) => setMainError(newError)), []);

  const [dialogError, setDialogError] = useState<DialogErrorItem | undefined>(services.appFrame.error.dialog.getError);
  useEffect(() => services.appFrame.error.dialog.onErrorChange((newError) => setDialogError(newError)), []);

  const ctxValue = useMemo(() => ({ main: mainError, dialog: dialogError }), [mainError, dialogError]);

  return (
    <ErrorContext.Provider value={ctxValue}>
      {children}
      <ErrorDialog error={dialogError} />
    </ErrorContext.Provider>
  );
};

export default ErrorProvider;
